import React, { useEffect, useCallback } from 'react';
import { useEngage } from '../../../engage';

const SitecorePersonalizationTracker = () => {
  const engage = useEngage();
  const sendPageViewEvent = useCallback(async () => {
    const response = await engage.pageView({
      channel: 'WEB',
      currency: 'GBP',
      page: window.location.origin + window.location.pathname,
      browser_id: engage.getBrowserId(),
      language: 'EN',
    });

    if (response) {
      window.engage = engage;
    }
  }, [engage]);

  useEffect(() => {
    if (engage && Object.keys(engage).length !== 0) {
      sendPageViewEvent();
    }
  }, [engage, sendPageViewEvent]);

  return <></>;
};

export default SitecorePersonalizationTracker;
